import React from 'react';
import { Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';

import { FilesUtils, Icon, useSettings } from 'app/main/components';
import { type MiddlewhereFile } from 'app/main/components/files-explorer/FilesUtils';

interface TotemFilesViewerProps {
	file: MiddlewhereFile;
	onOpen: VoidFunction;
}

export default function TotemFilesViewer(props: TotemFilesViewerProps) {
	const { t } = useSettings();

	const fileIcon = FilesUtils.getFileIcon(props.file);
	const fileSize = FilesUtils.getFileSize(props.file);

	return (
		<Card className="relative h-full rounded-lg" variant="outlined">
			<CardActionArea className="flex h-full flex-col justify-start" onClick={props.onOpen}>
				<CardMedia className="flex h-160 items-center justify-center">
					<Icon icon={fileIcon} size={96} />
				</CardMedia>
				<CardContent className="flex flex-col items-center justify-center text-center">
					<Typography gutterBottom variant="subtitle2">
						{props.file.name}
					</Typography>
					<Typography variant="body2" color="text.secondary" sx={{ maxHeight: '6vh', overflow: 'hidden' }}>
						{fileSize || t('TOTEM_CARD_FOLDER_TYPE')}
					</Typography>
				</CardContent>
			</CardActionArea>
		</Card>
	);
}
